import { useMemo, useState } from 'react';

import { useToggle } from '@repo/react-hooks/useToggle';

import { WorkspaceInviteDialog } from './WorkspaceInviteDialog';

export interface WorkspaceInviteOptions {
  /** Whether the dialog was opened after workspace creation */
  isCreation?: boolean;
  /** Some info text to display in the dialog */
  infoText?: React.ReactNode;
}

export const useWorkspaceInviteDialog = () => {
  const { value: isDialogOpen, setValue } = useToggle();

  // Whether the dialog was opened after workspace creation
  const [isCreation, setIsCreation] = useState<boolean>(false);

  return useMemo(
    () => ({
      dialogProps: {
        isOpen: isDialogOpen,
        setIsOpen: setValue,
        options: { isCreation },
      },
      DialogComponent: WorkspaceInviteDialog,
      openDialog: (options: WorkspaceInviteOptions = {}) => {
        setValue(true);
        setIsCreation(options.isCreation ?? false);
      },
      closeDialog: () => {
        setIsCreation(false);
        setValue(false);
      },
    }),
    [isDialogOpen, setValue, isCreation]
  );
};
